import list from "@/pages/company/member/List"
import detail from "@/pages/company/member/Detail"
import addMember from "@/pages/company/addMember/Index"
import memberCard from "@/pages/usercenter/businessCards/List";
import route from "@/components/router/Router"

export default [

    {
        path : "company-member-info",
        name : "company-member-info",
        meta : {
            title : "单位成员",
        },
        redirect : {
            name : "company-member-list",
        },
        component: route,
        children : [
            {
                path: 'company-member-list',
                name: 'company-member-list',
                meta: {
                    title: '单位成员-列表页'
                },
                component: list,
            },
            {
                path: 'company-member-detail/:id',
                name: 'company-member-detail',
                meta: {
                    title: '单位成员信息-单位成员'
                },
                component: detail,
            },
            {
                path: 'company-member-card-record/:uid',
                name: 'company-member-card-record',
                meta: {
                    title : '查看名片记录-单位成员',
                },
                component: memberCard,
            }
        ]
    },
    {
        path: 'company-member-more',
        name: 'company-member-more',
        meta: {
            title: '添加单位成员-单位管理'
        },
        component:addMember,
    },
]


// WEBPACK FOOTER //
// ./src/router/company/member/index.js